<template>
  <div class="preload-image">
    <ul class="house--review">
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
    </ul>
    <ul class="house--race">
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
    </ul>
    <div class="bg_street"></div>
    <div class="bg_meter"></div>
    <div class="br_street"></div>
    <div class="br_dice"></div>
  </div>
</template>
<script>
  export default {
    name: 'PreLoadImage',
    data () {
      return {
        msg: 'Card screen!'
      }
    }
  }
</script>
<style lang="scss">
.house--review{
  @for $i from 0 through 6{
    li:nth-of-type(#{$i + 1}){
      background: url("../assets/image/horse_preview_0#{$i}.png");
    }
  }
}
.house--race{
  @for $i from 0 through 6{
    li:nth-of-type(#{$i + 1}){
      background: url("../assets/image/horse_0#{$i}.png");
    }
  }
}
.bg_street{
   background: url("../assets/image/bg_street.jpg");
 }
.bg_meter{
background: url("../assets/image/meter.jpg");
}
.bg_dice{
  background: url("../assets/image/dice_bg.jpg");
}
</style>



// WEBPACK FOOTER //
// PreLoadImage.vue?311cb82d